'use client';

import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useResizeListener from '~/hooks/common/ui/useResizeListener';
import useRemoveQueryParams from '~/hooks/new-cars/useRemoveQueryParams';

type Props = {
  isFromSrp: boolean;
};

export default function MakesPageData({ isFromSrp }: Props) {
  useDataDogRUM();
  useRemoveQueryParams();
  useResizeListener(heliosSizes);
  useTrackClickEvents();
  useTrackRendered('car-merch-ui-srp-ncc-lip', isFromSrp);

  return null;
}
